import { ConfigFNType, HookReturnType, ParamsType } from './types'

export const makeMasterConfig = (
    configuration: ConfigFNType
): ((params?: ParamsType) => HookReturnType) => {
    return (params?: ParamsType) => {
        const { title, list } = configuration(params)
        return {
            detail: {},
            grid: { title, ...list },
            form: {}
        }
    }
}

export default makeMasterConfig
